import React from 'react'
import {debounce} from 'lodash'
import AutoComplete from 'material-ui-legacy/AutoComplete'

import errors from '../../lib/errors.js'
import ErrorDialog from './ErrorDialog'

/*
Props:
- name: field name
- selectedId: id value for the field
- value: text value
- dataStore: a Store component to be used to get autocomplete matches
- autoCompleteFilter: filter that will receive the field value
- autoCompleteAttribute: store attribute use as autocomplete data
- validatedOnChange: callback function for onChange, but including a
  validation flag and field name:
  callback(selectedId, Bool(isValid), this.props.name)
- required: boolean (false)
- errorMessage: Error message to be displayed (can be set by external form
  validation)
- debounceTime: throttling for autocomplete data requests. Default: 250ms
- maxSearchResults: Maximum results to show in dropdown. Default: 10
- openOnFocus: Should the dropdown be open on focus
- onUpdateInput: callback function for text being type:
  callback(value)
*/
class AutoCompleteSelect extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      value: (this.props.value || ''),
      selectedId: (this.props.selectedId || ''),
      dataSource: [],
      error: '',
      errorMessage: (this.props.errorMessage || '')
    }

    const debounceTime = this.props.debounceTime || 250
    this._loadData = debounce(this._loadData, debounceTime)
    this.maxSearchResults = this.props.maxSearchResults || 10
  }

  componentWillMount() {
    if (this.props.openOnFocus) this._loadData()
  }

  _loadData = () => {
    const DataStore = this.props.dataStore
    let filter = {}
    filter[this.props.autoCompleteFilter] = this.state.value
    DataStore.findAll(filter, [], 1, this.maxSearchResults)
    .then((result) => {
      const dataSource = result.data.map((item) => {
        return {
          text: item.attributes[this.props.autoCompleteAttribute],
          value: item.id
        }
      })
      this.setState({dataSource: dataSource})
    })
    .catch((error) => {
      this.setState({error: errors.unpack(error)})
    })
  }

  _change = (value) => {
    if (this.props.onUpdateInput) this.props.onUpdateInput(value)
    this.setState(
      {value: value, selectedId: ''},
      this._loadData
    )
  }

  _chosen = (chosenValue) => {
    if (typeof(chosenValue) !== 'object') {
      if (this.props.required) {
        this.setState({
          selectedId: '',
          errorMessage: 'You must choose an item'
        })
      }
    }
    else {
      this.setState({
        selectedId: chosenValue.value,
        value: chosenValue.text,
        errorMessage: ''
      },
      () => {
        this.props.validatedOnChange(
          chosenValue.value,
          (this.props.required ? Boolean(this.state.selectedId) : true),
          this.props.name
        )
      })
    }
  }

  _closeErrorDialog = () => this.setState({error: ''})

  render() {
    let autoCompleteStyle = this.props.style || {}

    return (
      <div>
        <AutoComplete
          value={this.state.value}
          style={autoCompleteStyle}
          hintText={this.props.hintText}
          filter={AutoComplete.noFilter}
          floatingLabelText={this.props.floatingLabelText}
          dataSource={this.state.dataSource}
          onUpdateInput={this._change}
          onNewRequest={this._chosen}
          fullWidth={this.props.fullWidth}
          maxSearchResults={this.maxSearchResults}
          searchText={this.state.value}
          errorText={this.state.errorMessage}
          openOnFocus={this.props.openOnFocus}
        />

        {Boolean(this.state.error) &&
          <ErrorDialog
            open={Boolean(this.state.error)}
            closeCallback={this._closeErrorDialog}
            title="Couldn't read autocomplete data">
            <p>
              <strong>Error:</strong> {this.state.error}
            </p>
          </ErrorDialog>
        }

      </div>
    )
  }
}

export default AutoCompleteSelect



// WEBPACK FOOTER //
// ./src/components/UI/AutoCompleteSelect.jsx